import styled from 'styled-components';
import { StyledFooter } from '@components/Footer/Footer.styled';

export const LoadingContent = styled.div`
    display: flex;
    background: linear-gradient(56.65deg, #e9f3f8 0%, #fff 100%);
    box-shadow: inset 0 5px 17px 0 rgba(0, 0, 0, 0.1);
    flex-direction: column;
    align-items: center;
    padding-top: 208px;
    padding-bottom: 229px;
    flex: 1;

    h1 {
        font-size: 32px;
        font-weight: 300;
        line-height: 38px;
        letter-spacing: 0;
        margin-bottom: 25px;
    }
`;

export const Progress = styled.div`
    width: 645px;
    height: 10px;
    background: #d9dce0;
    border-radius: 8px;
    overflow: hidden;
    @media screen and (max-width: 768px) {
        width: 545px;
    }
    @media screen and (max-width: 425px) {
        width: 345px;
    }
`;

export const ProgressBar = styled.span`
    display: block;
    height: 100%;
    border-radius: 8px;
    background: linear-gradient(89.99deg, #1578b4 0%, rgba(3, 129, 95, 0.5) 49.26%, #b02b2a 100%);
    transition: 0.4s linear;
    animation: progress-animation 4s linear;

    @keyframes progress-animation {
        0% {
            width: 0%;
        }
    }
`;

export const Styledfooter = styled(StyledFooter)`
    height: 147px;
    @media screen and (max-width: 768px) {
        height: 219px;
    }
    @media screen and (max-width: 425px) {
        height: 409px;
    }
`;
